export default __webpack_public_path__ + "static/media/le_croise17.1c96ccba.jpg";